import { render, staticRenderFns } from "./SignOutButton.vue?vue&type=template&id=27aad5ea&scoped=true&"
import script from "./SignOutButton.vue?vue&type=script&lang=js&"
export * from "./SignOutButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aad5ea",
  null
  
)

export default component.exports